<template>
    <h5 class="inner_heading" :class="classes">{{ text }}</h5>
</template>

<script>
export default {
    name: 'innerHeading',
    props: {
        text: {
            type: String,
            default: '',
        },
        classes: {
            type: String,
            default: '',
        }
    },
};
</script>

<style scoped>
.inner_heading {
    @apply text-black-900 dark:text-gray-500 font-medium mb-6 text-base;
}
</style>
